import Icon from 'veui/components/Icon'

Icon.register({
  'thumb-up': {
    paths: [
      {
        d: 'M530.19 704H96a32 32 0 01-32-32V288a32 32 0 0132-32h108.91L298 83.71a96.84 96.84 0 01182 46V224h186.7a64 64 0 0163.3 73.73l-41.63 270.6A160 160 0 01530.19 704zM256 640h274.19a96 96 0 0094.88-81.4L666.7 288H448a32 32 0 01-32-32V129.73a32.84 32.84 0 00-61.73-15.6L256 296.09V640zm-128 0h64V320h-64v320z'
      }
    ],
    width: '768',
    height: '768'
  }
})
